import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ProgressBar } from "react-loader-spinner";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import NsiModalWindow from "../NsiModalWindow/NsiModalWindow";
import ConfirmModalWindow from "../ConfirmModalWindow/ConfirmModalWindow";
import TableComponent from "../../GeneralComponents/SearchTable/tableComponent";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { optionsAdministrativeProcedures } from "../NsiModalWindow/NsiModalWindowSettings";
import { MAIN_URL, PORT, API_GET_ADMIN_PROC } from "../../../constants/constants";
import { TABLE_COLUMNS } from "./AdministrativeProceduresSettings";

import styles from "./AdministrativeProcedures.module.css";

export default function AdministrativeProcedures() {
  const [data, setData] = useState([]);
  const [currentId, setCurrentId] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [mode, setMode] = useState("");
  const [dataForEdit, setDataForEdit] = useState({});
  const [selectedPage, setSelectedPage] = useState(0);

  const navigate = useNavigate();

  const { sortedMenuNames } = useSelector((state) => state.roleControllerReducer);

  const addNoteAccess = useChapterActionIdMatch(
    sortedMenuNames?.NSI?.addingEntriesToDirectoriesClassifiers?.chapterActionId,
  );
  const editNoteAccess = useChapterActionIdMatch(
    sortedMenuNames?.NSI?.editingEntriesInDirectoriesClassifiers?.chapterActionId,
  );
  const removeNoteAccess = useChapterActionIdMatch(
    sortedMenuNames?.NSI?.removingRecordsFromDirectoriesClassifiers?.chapterActionId,
  );

  const handleCheckboxClick = (id) => {
    setCurrentId(id);
    setCurrentRow(data.find((item) => Number(item.code) === Number(id)));
  };

  const handleButtonClick = (e) => {
    switch (e.target.id) {
      case "add":
        setMode(e.target.id);
        setShowModal(true);
        break;
      case "edit":
        if (currentId) {
          setMode(e.target.id);
          setDataForEdit(data.find((item) => Number(item.code) === Number(currentId)));
          setShowModal(true);
        }
        break;
      case "delete":
        if (currentId) setShowConfirmModal(true);
        break;
      default:
        break;
    }
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  const handleRowSelect = (rowData) => {
    handleCheckboxClick(rowData.code);
  };

  const fetchData = async () => {
    const request = await fetchWithToken(MAIN_URL + PORT + API_GET_ADMIN_PROC);
    const response = await request.json();
    setData(response.map((item) => ({ ...item, id: item.code })));
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
    fetchPageData(0);
  }, []);

  return (
    <>
      {isLoading ? (
        <div className={styles["progress-bar-wrapper"]}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            borderColor="#D2AF8E"
            barColor="#BC8653"
          />
        </div>
      ) : (
        <div className={styles["content-container"]}>
          <p
            className={styles["back-block"]}
            onClick={() => navigate(-1)}>
            <span className={styles["back-icon"]}></span>
            <p className={styles["back-text"]}>{"Вернуться к НСИ"}</p>
          </p>
          <h2 className={styles["main-text"]}>Административные процедуры</h2>
          <div className={styles["buttons-container"]}>
            {addNoteAccess && (
              <div
                className={styles["add-btn"]}
                id={"add"}
                onClick={(e) => handleButtonClick(e)}>
                Добавить строку
              </div>
            )}
            {editNoteAccess && (
              <div
                className={`${styles["edit-btn"]} ${!currentId ? styles.disabled_button : ""}`}
                id={"edit"}
                onClick={(e) => handleButtonClick(e)}>
                Редактировать строку
              </div>
            )}
            {removeNoteAccess && (
              <div
                className={`${styles["delete-btn"]} ${
                  !currentId || currentRow.isLocked ? styles.disabled_button : ""
                }`}
                id={"delete"}
                onClick={(e) => handleButtonClick(e)}>
                Удалить строку
              </div>
            )}
          </div>
          <TableComponent
            columns={TABLE_COLUMNS}
            data={data}
            fetchData={fetchPageData}
            onRowSelect={handleRowSelect}
            totalPages={1}
            totalElements={data.length}
            selectedPage={0}
            isPaginated={false}
            pageSize={data.length}
          />
          {showModal && (
            <NsiModalWindow
              setShowModal={setShowModal}
              showModal={showModal}
              modalWindowInputs={optionsAdministrativeProcedures}
              fetchData={fetchData}
              mode={mode}
              dataForEdit={dataForEdit}
              setDataForEdit={setDataForEdit}
              id={currentId}
              setCurrentId={setCurrentId}
            />
          )}
          {showConfirmModal && (
            <ConfirmModalWindow
              setShowModal={setShowConfirmModal}
              showModal={showConfirmModal}
              fetchData={fetchData}
              id={currentId}
              setCurrentId={setCurrentId}
            />
          )}
          <div
            className={styles["close-button"]}
            onClick={() => navigate(-1)}>
            Назад
          </div>
        </div>
      )}
    </>
  );
}
